import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { getFirstLastNameObj, joinStrings } from '../../utils/format';
import { QcsTypography } from '../common/basic/QcsTypography';
import { TourniquetInvitationContainer } from './TourniquetInvitationContainer';
import { InvitationDto } from '@api/models/invitation/InvitationDto';

interface Props {
  invitation: InvitationDto;
}

export const TourniquetInvitationIssueCompany: FC<Props> = ({ invitation }) => {
  const { t } = useTranslation();

  const m1 = t('tourniquet.issueCompany')?.split('{0}');

  return (
    <TourniquetInvitationContainer icon="error">
      <QcsTypography>
        {m1?.[0]}
        <strong>
          {joinStrings(
            getFirstLastNameObj(invitation.employee),
            invitation.employee?.phone,
            invitation.employee?.email
          )}
        </strong>
        {m1?.[1]}
      </QcsTypography>
    </TourniquetInvitationContainer>
  );
};
